import { recoveryFlatReports } from "@/analytics/recoveryDrillThrough";
import type { RecoveryFilters } from "@/analytics/recovery.api";
import { RecoveryFlatTable } from "@/components/RecoveryFlatTable";
import { RecoveryHierarchyTable } from "@/components/RecoveryHierarchyTable";

type Props = { filters: RecoveryFilters };

export function RecoveryTablesPanel({ filters }: Props) {
  return (
    <section className="space-y-3">
      <h2 className="text-base font-semibold text-foreground">Recovery Tables</h2>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        {recoveryFlatReports.map((report) => (
          <RecoveryFlatTable
            key={report.id}
            title={report.title}
            endpoint={report.endpoint}
            filters={filters}
            normalizer={report.normalizer}
            sortable={report.sortable}
          />
        ))}
      </div>

      <RecoveryHierarchyTable filters={filters} />
    </section>
  );
}
